import { ReactNode, useState } from 'react'

type RemarkPropTypes = {
  title?: string
  titleComponent?: ReactNode
  learnMoreText?: string
  lineHeight?: number
  remarkClassName?: string
  children?: ReactNode
  isElite?: boolean
}

export default function Remark({
  title,
  titleComponent,
  children,
  lineHeight,
  remarkClassName,
  isElite
}: RemarkPropTypes) {
  const [childHeight, setChildHeight] = useState(lineHeight ?? 32)
  return (
    <div
      className={`rounded-[12px] ${isElite ? 'bg-[#FFF2DF]' : 'bg-[#E6F2FF]'} text-[#004D99] p-5 flex flex-col gap-3 ${remarkClassName ?? ''}`}
    >
      <div className='flex gap-3 items-center'>
        <div
          style={{ height: `${childHeight}px` }}
          className={`h-8 ${isElite ? 'bg-[#DB824F]' : 'bg-[#004D99]'} w-[3px] rounded-lg  opacity-95`}
        />
        <div
          ref={(ref) => {
            if (ref && !lineHeight) setChildHeight(() => ref?.clientHeight - 8 ?? 32)
          }}
          className={`${isElite ? 'text-[#CC5C2D]' : 'text-[#004D99]'} leading-[150%] text-[13px] flex-1`}
        >
          {children ?? <>Ranking unavailable for Regular Funds Refer to Direct fund analysis. </>}
        </div>
      </div>
      {titleComponent ?? (title && <div className='text-black text-[16px] font-[700]'>{title}</div>)}
    </div>
  )
}
